import type { ItemAttributes } from '.';

export interface WrapperItemAttributes extends ItemAttributes {
  flexDirection: 'column';
  justifyContent: 'flex-start';
}

export enum BUTTONS_SPACING_OPTIONS {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}
